var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    [
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: ["root", "otr-digital-producer"],
              expression: "['root','otr-digital-producer']",
            },
          ],
          attrs: { label: "Address Type" },
        },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "Select" },
              model: {
                value: _vm.me.addrType,
                callback: function ($$v) {
                  _vm.$set(_vm.me, "addrType", $$v)
                },
                expression: "me.addrType",
              },
            },
            _vm._l(_vm.typeList, function (item) {
              return _c("el-option", {
                key: item,
                attrs: { label: item, value: item },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: ["root", "otr-digital-producer"],
              expression: "['root','otr-digital-producer']",
            },
          ],
          attrs: { label: "Address 1" },
        },
        [
          _c("el-input", {
            model: {
              value: _vm.me.addr1,
              callback: function ($$v) {
                _vm.$set(_vm.me, "addr1", $$v)
              },
              expression: "me.addr1",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: ["root", "otr-digital-producer"],
              expression: "['root','otr-digital-producer']",
            },
          ],
          attrs: { label: "Address 2" },
        },
        [
          _c("el-input", {
            model: {
              value: _vm.me.addr2,
              callback: function ($$v) {
                _vm.$set(_vm.me, "addr2", $$v)
              },
              expression: "me.addr2",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: ["root", "otr-digital-producer"],
              expression: "['root','otr-digital-producer']",
            },
          ],
          attrs: { label: "Address 3" },
        },
        [
          _c("el-input", {
            model: {
              value: _vm.me.addr3,
              callback: function ($$v) {
                _vm.$set(_vm.me, "addr3", $$v)
              },
              expression: "me.addr3",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "City" } },
        [
          _c("el-input", {
            model: {
              value: _vm.me.city,
              callback: function ($$v) {
                _vm.$set(_vm.me, "city", $$v)
              },
              expression: "me.city",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "State" } },
        [
          _c("el-input", {
            model: {
              value: _vm.me.state,
              callback: function ($$v) {
                _vm.$set(_vm.me, "state", $$v)
              },
              expression: "me.state",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "postalCode" } },
        [
          _c("el-input", {
            model: {
              value: _vm.me.postalCode,
              callback: function ($$v) {
                _vm.$set(_vm.me, "postalCode", $$v)
              },
              expression: "me.postalCode",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Country" } },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "Select" },
              model: {
                value: _vm.me.countryCode,
                callback: function ($$v) {
                  _vm.$set(_vm.me, "countryCode", $$v)
                },
                expression: "me.countryCode",
              },
            },
            _vm._l(_vm.countryList, function (item) {
              return _c("el-option", {
                key: item.countryCode,
                attrs: { label: item.country, value: item.countryCode },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: ["root", "otr-digital-producer"],
              expression: "['root','otr-digital-producer']",
            },
          ],
        },
        [
          _c("hr", { staticClass: "spliter" }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "custom-label", staticStyle: { width: "100%" } },
            [
              _vm._v("Billing Info "),
              _c(
                "el-checkbox",
                {
                  on: { change: _vm.copyAddress },
                  model: {
                    value: _vm.isSame,
                    callback: function ($$v) {
                      _vm.isSame = $$v
                    },
                    expression: "isSame",
                  },
                },
                [_vm._v("(Same as above )")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Prefix" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "Select" },
                  model: {
                    value: _vm.me.billingInfo.prefix,
                    callback: function ($$v) {
                      _vm.$set(_vm.me.billingInfo, "prefix", $$v)
                    },
                    expression: "me.billingInfo.prefix",
                  },
                },
                _vm._l(_vm.prefixList, function (item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: item, value: item },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Given Name" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.me.billingInfo.givenName,
                  callback: function ($$v) {
                    _vm.$set(_vm.me.billingInfo, "givenName", $$v)
                  },
                  expression: "me.billingInfo.givenName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Middle Name" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.me.billingInfo.middleName,
                  callback: function ($$v) {
                    _vm.$set(_vm.me.billingInfo, "middleName", $$v)
                  },
                  expression: "me.billingInfo.middleName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Surname" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.me.billingInfo.lastName,
                  callback: function ($$v) {
                    _vm.$set(_vm.me.billingInfo, "lastName", $$v)
                  },
                  expression: "me.billingInfo.lastName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Suffix" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "Select" },
                  model: {
                    value: _vm.me.billingInfo.suffix,
                    callback: function ($$v) {
                      _vm.$set(_vm.me.billingInfo, "suffix", $$v)
                    },
                    expression: "me.billingInfo.suffix",
                  },
                },
                _vm._l(_vm.suffixList, function (item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: item, value: item },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Address 1" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.me.billingInfo.addr1,
                  callback: function ($$v) {
                    _vm.$set(_vm.me.billingInfo, "addr1", $$v)
                  },
                  expression: "me.billingInfo.addr1",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Address 2" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.me.billingInfo.addr2,
                  callback: function ($$v) {
                    _vm.$set(_vm.me.billingInfo, "addr2", $$v)
                  },
                  expression: "me.billingInfo.addr2",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Address 3" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.me.billingInfo.addr3,
                  callback: function ($$v) {
                    _vm.$set(_vm.me.billingInfo, "addr3", $$v)
                  },
                  expression: "me.billingInfo.addr3",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "City" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.me.billingInfo.city,
                  callback: function ($$v) {
                    _vm.$set(_vm.me.billingInfo, "city", $$v)
                  },
                  expression: "me.billingInfo.city",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "State" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.me.billingInfo.state,
                  callback: function ($$v) {
                    _vm.$set(_vm.me.billingInfo, "state", $$v)
                  },
                  expression: "me.billingInfo.state",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "postalCode" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.me.billingInfo.postalCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.me.billingInfo, "postalCode", $$v)
                  },
                  expression: "me.billingInfo.postalCode",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Country" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "Select" },
                  model: {
                    value: _vm.me.billingInfo.countryCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.me.billingInfo, "countryCode", $$v)
                    },
                    expression: "me.billingInfo.countryCode",
                  },
                },
                _vm._l(_vm.countryList, function (item) {
                  return _c("el-option", {
                    key: item.countryCode,
                    attrs: { label: item.country, value: item.countryCode },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        [
          _vm.checkPermission(["root", "otr-digital-producer"])
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v("Update")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-link",
            {
              staticStyle: { "margin-left": "20px" },
              attrs: { type: "info", href: "/#/users" },
            },
            [_vm._v("Back")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }